import { nonSeeded } from "../../fable_modules/fable-library.3.7.20/Random.js";
import { empty as empty_2, append, toList, singleton, collect, delay, toArray } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { rangeDouble } from "../../fable_modules/fable-library.3.7.20/Range.js";
import { comparePrimitives, uncurry, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { RouterModule_urlSegments } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { empty as empty_1, ofArray, map, singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/List.js";
import { toString, Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, equals as equals_1, record_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { ValidatedUrlModule_value as ValidatedUrlModule_value_1, ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { stackClasses, delayAsync, logei } from "../../Utils.js";
import { toFail, split, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { bind, defaultArgWith, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { empty, ofList } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { tryPick, equalsWith } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { setItem, getItem } from "../../LocalStorage.js";
import * as react from "react";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { SaveStatus_OfLoadState_3AB583F7, SaveStatus as SaveStatus_3, LoadState$2 } from "../../Global.js";
import { useIsComponentMounted } from "../../Components/Hooks/IsComponentMounted.js";
import { attachDisposableEvent } from "../../Components/Hooks/Common.js";
import { info, error } from "../../Components/Message/Message.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { Prop, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { secondary, ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { postLogin as postLogin_1, postOtp as postOtp_1, getCSRFCookie } from "./Api.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import "../../../src/Containers/Login/View.scss";


function generateName() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const rnd = nonSeeded();
    const arg = toArray(delay(() => collect((matchValue) => singleton(chars[rnd.Next1(chars.length)]), rangeDouble(1, 1, 6))));
    return arg.join('');
}

function reloadPageOrGoToStart() {
    if (equals(RouterModule_urlSegments(window.location.hash, 1), singleton_1("Login"))) {
        window.location.href = "/";
    }
    else {
        window.location.reload();
    }
}

class MFAKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OTP"];
    }
}

function MFAKind$reflection() {
    return union_type("Containers.Login.View.MFAKind", [], MFAKind, () => [[]]);
}

class LoginStep extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UsernamePasswordStep1", "UsernamePasswordStep2"];
    }
}

function LoginStep$reflection() {
    return union_type("Containers.Login.View.LoginStep", [], LoginStep, () => [[], [["Item", MFAKind$reflection()]]]);
}

export class Feature extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Feature$reflection() {
    return record_type("Containers.Login.View.Feature", [], Feature, () => [["Name", string_type]]);
}

export function fetchFeatures(state, unitVar) {
    let matchValue;
    startImmediate((matchValue = ValidatedUrlModule_create(new UrlKind(0, "/feature/")), (matchValue.tag === 1) ? ((logei(toText(printf("[fetchFeatures] BadUrl: %s"))(matchValue.fields[0])), singleton_2.Return())) : singleton_2.Delay(() => {
        let parseFn, arg;
        return singleton_2.Bind((parseFn = ((arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1) => {
            const str = arg_1;
            return equals_1(list_type(Feature$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(Feature$reflection()), arg, Http_get_ExtraCoders().Value)), str);
        })), singleton_2.Delay(() => singleton_2.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton_2.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals_1(list_type(Feature$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }))), (_arg_1) => {
            const featureResult = _arg_1;
            return singleton_2.Combine((featureResult.tag === 1) ? ((logei(toText(printf("[fetchFeatures] Error: %s"))(featureResult.fields[0])), singleton_2.Zero())) : ((state[1]({
                Feature: ofList(map((feature) => feature.Name, featureResult.fields[0]), {
                    Compare: comparePrimitives,
                }),
            }), singleton_2.Zero())), singleton_2.Delay(() => singleton_2.Return()));
        });
    })));
}

export class Country extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Swedish", "Norwegian", "Danish", "Finnish"];
    }
}

export function Country$reflection() {
    return union_type("Containers.Login.View.Country", [], Country, () => [[], [], [], []]);
}

export function CountryModule_tryParse(_arg) {
    switch (_arg) {
        case "Swedish": {
            return new Country(0);
        }
        case "Norwegian": {
            return new Country(1);
        }
        case "Danish": {
            return new Country(2);
        }
        case "Finnish": {
            return new Country(3);
        }
        default: {
            return void 0;
        }
    }
}

export function CountryModule_asString(c) {
    return toString(c);
}

export function languageToCountryParser(language) {
    let primaryLangaugeSubTag;
    const matchValue = split(language, ["-"], 2, 0);
    primaryLangaugeSubTag = (((!equalsWith((x, y) => (x === y), matchValue, null)) && (matchValue.length === 1)) ? matchValue[0] : (((!equalsWith((x_1, y_1) => (x_1 === y_1), matchValue, null)) && (matchValue.length === 2)) ? matchValue[0] : toFail(printf("A very unlikely event"))));
    const matchValue_1 = primaryLangaugeSubTag.toLocaleLowerCase();
    switch (matchValue_1) {
        case "sv": {
            return new Country(0);
        }
        case "nb":
        case "nn":
        case "no": {
            return new Country(1);
        }
        case "fi": {
            return new Country(3);
        }
        case "da": {
            return new Country(2);
        }
        default: {
            return void 0;
        }
    }
}

export function getCurrentCountry() {
    return defaultArgWith(bind(CountryModule_tryParse, getItem("Login", "SelectedLanguage")), () => {
        let value;
        return defaultArg(tryPick(languageToCountryParser, (value = [], defaultArg(navigator.languages, value))), new Country(0));
    });
}

export function setCurrentCountry(c) {
    setItem("Login", "SelectedLanguage", CountryModule_asString(c));
}

export function renderCountry(countryState, c) {
    const cssClass = equals(countryState[0], c) ? "FlagContainer FlagContainerSelected" : "FlagContainer";
    const children = toList(delay(() => {
        let flagUrl;
        const _arg_1 = ValidatedUrlModule_create(new UrlKind(3, "/img/flags/" + ((c.tag === 1) ? "no.svg" : ((c.tag === 3) ? "fi.svg" : ((c.tag === 2) ? "dk.svg" : "se.svg")))));
        flagUrl = ((_arg_1.tag === 1) ? toFail(printf("ValidatedUrl Failed: %s"))(_arg_1.fields[0]) : ValidatedUrl__get_Value(_arg_1.fields[0]));
        return singleton(react.createElement("img", {
            src: flagUrl,
            className: "Flag",
        }));
    }));
    return react.createElement("button", {
        onClick: (_arg) => {
            setCurrentCountry(c);
            countryState[1](c);
        },
        className: cssClass,
    }, ...children);
}

export const renderLogin = FunctionComponent_Of_Z5A158BBF(() => {
    let children_25, inputRecord_2;
    const featureState = react.useState({
        Feature: empty({
            Compare: comparePrimitives,
        }),
    });
    const usernameState = react.useState("");
    const passwordState = react.useState("");
    const loginStepState = react.useState(new LoginStep(0));
    const otpState = react.useState("");
    const forgotPasswordModalVisibleState = react.useState(false);
    const passwordInputRef = react.useRef(void 0);
    const signInButtonRef = react.useRef(void 0);
    const otpInputRef = react.useRef(void 0);
    const submitOtpButtonRef = react.useRef(void 0);
    const countryState = react.useState(getCurrentCountry());
    const loginLoadState = react.useState(new LoadState$2(0));
    const loginOtpLoadState = react.useState(new LoadState$2(0));
    const signInButtonSaveState = react.useState(new SaveStatus_3(0));
    const submitOtpButtonSaveState = react.useState(new SaveStatus_3(0));
    const isComponentMounted = useIsComponentMounted();
    const isAlreadyLoggedIn = react.useState(false);
    const randomName = generateName();
    const secondsState = react.useState(5);
    react.useEffect(() => {
        let matchValue;
        startImmediate((matchValue = ValidatedUrlModule_create(new UrlKind(0, "/Session/")), (matchValue.tag === 1) ? ((logei(toText(printf("[checkIfAlreadyLoggedIn] BadUrl: %s"))(matchValue.fields[0])), singleton_2.Return())) : singleton_2.Delay(() => singleton_2.Bind(Http_send(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value_1(matchValue.fields[0]))))), (_arg) => singleton_2.Return((_arg.statusCode === 200) ? (isAlreadyLoggedIn[1](true)) : (isAlreadyLoggedIn[1](false)))))));
    }, []);
    react.useEffect(() => {
        fetchFeatures(featureState, void 0);
    }, []);
    react.useEffect(() => {
        const disp = (() => {
        const matchValue_2 = [isAlreadyLoggedIn[0], isComponentMounted.current];
        let pattern_matching_result;
        if (matchValue_2[0]) {
            if (matchValue_2[1]) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const id = window.setInterval(() => {
                    secondsState[1]((s) => {
                        if (s <= 0) {
                            reloadPageOrGoToStart();
                            return 0;
                        }
                        else {
                            return (s - 1) | 0;
                        }
                    });
                }, 1000);
                return {
                    Dispose() {
                        window.clearInterval(id);
                    },
                };
            }
            case 1: {
                return {
                    Dispose() {
                    },
                };
            }
        }
    })();
        return () => disp.Dispose();
    }, [isAlreadyLoggedIn[0]]);
    react.useEffect(() => {
        signInButtonSaveState[1](SaveStatus_OfLoadState_3AB583F7(loginLoadState[0]));
    }, [loginLoadState[0]]);
    react.useEffect(() => {
        submitOtpButtonSaveState[1](SaveStatus_OfLoadState_3AB583F7(loginOtpLoadState[0]));
    }, [loginOtpLoadState[0]]);
    react.useEffect(() => {
        const disp = (() => {
        const attachToDOMNodeOpt = passwordInputRef.current;
        return (attachToDOMNodeOpt == null) ? {
            Dispose() {
            },
        } : attachDisposableEvent((e) => {
            if (e.key === "Enter") {
                const matchValue_4 = signInButtonRef.current;
                if (matchValue_4 == null) {
                }
                else {
                    const signInButton = matchValue_4;
                    signInButton.click();
                }
            }
        }, attachToDOMNodeOpt, "keydown");
    })();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        const disp = (() => {
        const attachToDomNodeOpt = otpInputRef.current;
        return (attachToDomNodeOpt == null) ? {
            Dispose() {
            },
        } : attachDisposableEvent((e_1) => {
            if (e_1.key === "Enter") {
                const matchValue_6 = submitOtpButtonRef.current;
                if (matchValue_6 == null) {
                }
                else {
                    const submitOtpButton = matchValue_6;
                    submitOtpButton.click();
                }
            }
        }, attachToDomNodeOpt, "keydown");
    })();
        return () => disp.Dispose();
    });
    let loginErrorMessageHtml;
    const matchValue_10 = loginLoadState[0];
    loginErrorMessageHtml = ((matchValue_10.tag === 3) ? error(matchValue_10.fields[0].split("")) : react.createElement(react.Fragment, {}));
    let loginOtpErrorMessageHtml;
    const matchValue_11 = loginOtpLoadState[0];
    loginOtpErrorMessageHtml = ((matchValue_11.tag === 3) ? error(matchValue_11.fields[0].split("")) : react.createElement(react.Fragment, {}));
    let forgotPasswordModalHtml;
    const matchValue_12 = forgotPasswordModalVisibleState[0];
    forgotPasswordModalHtml = (matchValue_12 ? renderAsModal("Forgot password", react.createElement("div", {}, "If you forgot your password, contact support-sbs@svea.com and we will help you."), new MessageType(0), "Close", (_arg_5) => {
        forgotPasswordModalVisibleState[1](false);
    }) : react.createElement(react.Fragment, {}));
    let boxContentHtml;
    const matchValue_13 = loginStepState[0];
    if (matchValue_13.tag === 1) {
        const children_27 = [(children_25 = [react.createElement("h1", {
            className: "headers__heading",
        }, "Verify Your Identity"), react.createElement("div", {}, "A one-time password has been sent to your email address.")], react.createElement("div", {
            className: "box__headers",
        }, ...children_25)), render_1()((inputRecord_2 = TextProps$1_GetDefault(), new TextProps$1(otpState[0], "text", inputRecord_2.Classes, (e_4) => {
            const arg_19 = Browser_Types_Event__Event_get_Value(e_4);
            otpState[1](arg_19);
        }, inputRecord_2.Disabled, inputRecord_2.LabelText, "login-otp", inputRecord_2.ValidationFn, inputRecord_2.DynamicWidth, ofArray([new HTMLAttr(128, "Enter the one-time password"), new HTMLAttr(54, "off"), new Prop(3, otpInputRef)]), inputRecord_2.OnBlur, inputRecord_2.OnFocus, inputRecord_2.AutoComplete, randomName))), loginOtpErrorMessageHtml, main(new ButtonProps("Submit", defaultProps.Content, (_arg_9) => {
            loginOtpLoadState[1](new LoadState$2(1));
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(getCSRFCookie(), (_arg_3) => {
                const csrfCookie_1 = _arg_3;
                if (csrfCookie_1.tag === 0) {
                    return singleton_2.Bind(postOtp_1(usernameState[0], otpState[0]), (_arg_4) => {
                        const result_1 = _arg_4;
                        if (result_1.tag === 0) {
                            const dto_1 = result_1.fields[0];
                            if (dto_1.success) {
                                loginOtpLoadState[1](new LoadState$2(2, dto_1));
                                startImmediate(delayAsync(200, () => {
                                    reloadPageOrGoToStart();
                                }));
                                return singleton_2.Zero();
                            }
                            else {
                                loginOtpLoadState[1](new LoadState$2(3, dto_1.message));
                                return singleton_2.Zero();
                            }
                        }
                        else {
                            startImmediate(delayAsync(2000, () => {
                                submitOtpButtonSaveState[1](new SaveStatus_3(0));
                            }));
                            loginOtpLoadState[1](new LoadState$2(3, result_1.fields[0]));
                            return singleton_2.Zero();
                        }
                    });
                }
                else {
                    loginLoadState[1](new LoadState$2(3, csrfCookie_1.fields[0]));
                    return singleton_2.Zero();
                }
            })));
        }, defaultProps.Disabled, defaultProps.Id, submitOtpButtonSaveState[0], singleton_1(new Prop(3, submitOtpButtonRef)), defaultProps.ExtraClasses, defaultProps.Icon))];
        boxContentHtml = react.createElement("div", {
            className: "login__box",
        }, ...children_27);
    }
    else {
        const children_19 = toList(delay(() => {
            let children_11, children_9;
            return append(singleton((children_11 = [react.createElement("h1", {
                className: "headers__heading",
            }, "Sign in"), react.createElement("h5", {
                className: "headers__sub-heading",
            }, "Fenix"), (children_9 = [renderCountry(countryState, new Country(0)), renderCountry(countryState, new Country(2)), renderCountry(countryState, new Country(3)), renderCountry(countryState, new Country(1))], react.createElement("div", {
                className: "Flags",
            }, ...children_9))], react.createElement("div", {
                className: "box__headers",
            }, ...children_11))), delay(() => {
                let inputRecord;
                return append(singleton(render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(usernameState[0], inputRecord.Type, inputRecord.Classes, (e_2) => {
                    const arg_17 = Browser_Types_Event__Event_get_Value(e_2);
                    usernameState[1](arg_17);
                }, inputRecord.Disabled, inputRecord.LabelText, "username", inputRecord.ValidationFn, inputRecord.DynamicWidth, singleton_1(new HTMLAttr(128, "Username")), inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))), delay(() => {
                    let inputRecord_1;
                    return append(singleton(render_1()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(passwordState[0], "password", inputRecord_1.Classes, (e_3) => {
                        const arg_18 = Browser_Types_Event__Event_get_Value(e_3);
                        passwordState[1](arg_18);
                    }, inputRecord_1.Disabled, inputRecord_1.LabelText, "password", inputRecord_1.ValidationFn, inputRecord_1.DynamicWidth, ofArray([new HTMLAttr(128, "Password"), new Prop(3, passwordInputRef)]), inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name)))), delay(() => append(singleton(loginErrorMessageHtml), delay(() => append(singleton(react.createElement("div", {
                        className: "box__forgot-password",
                        onClick: (_arg_6) => {
                            forgotPasswordModalVisibleState[1](true);
                        },
                    }, "Forgot your password?")), delay(() => append(singleton(forgotPasswordModalHtml), delay(() => append(singleton(main(new ButtonProps("Sign in", defaultProps.Content, (_arg_7) => {
                        loginLoadState[1](new LoadState$2(1));
                        startImmediate(singleton_2.Delay(() => singleton_2.Bind(getCSRFCookie(), (_arg_1) => {
                            const csrfCookie = _arg_1;
                            if (csrfCookie.tag === 0) {
                                const hashUrl = window.location.hash;
                                return singleton_2.Bind(postLogin_1(usernameState[0], passwordState[0], hashUrl), (_arg_2) => {
                                    const result = _arg_2;
                                    if (result.tag === 0) {
                                        const dto = result.fields[0];
                                        const matchValue_7 = [dto.success, dto.requiresOtp];
                                        let pattern_matching_result_1;
                                        if (matchValue_7[0]) {
                                            pattern_matching_result_1 = 1;
                                        }
                                        else if (matchValue_7[1]) {
                                            pattern_matching_result_1 = 1;
                                        }
                                        else {
                                            pattern_matching_result_1 = 0;
                                        }
                                        switch (pattern_matching_result_1) {
                                            case 0: {
                                                startImmediate(delayAsync(2000, () => {
                                                    signInButtonSaveState[1](new SaveStatus_3(0));
                                                }));
                                                loginLoadState[1](new LoadState$2(3, dto.message));
                                                return singleton_2.Zero();
                                            }
                                            case 1: {
                                                if (dto.requiresOtp) {
                                                    loginLoadState[1](new LoadState$2(2, dto));
                                                    loginStepState[1](new LoginStep(1, new MFAKind(0)));
                                                    return singleton_2.Zero();
                                                }
                                                else {
                                                    loginLoadState[1](new LoadState$2(2, dto));
                                                    startImmediate(delayAsync(200, () => {
                                                        reloadPageOrGoToStart();
                                                    }));
                                                    return singleton_2.Zero();
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        loginLoadState[1](new LoadState$2(3, result.fields[0]));
                                        return singleton_2.Zero();
                                    }
                                });
                            }
                            else {
                                loginLoadState[1](new LoadState$2(3, csrfCookie.fields[0]));
                                return singleton_2.Zero();
                            }
                        })));
                    }, defaultProps.Disabled, defaultProps.Id, signInButtonSaveState[0], singleton_1(new Prop(3, signInButtonRef)), singleton_1("login-btn"), defaultProps.Icon))), delay(() => (equals(countryState[0], new Country(0)) ? append(singleton(react.createElement("div", {
                        className: "separator",
                    }, "Secure login")), delay(() => {
                        let children_17, props_17;
                        return singleton(secondary(new ButtonProps(defaultProps.Text, (children_17 = [(props_17 = [new HTMLAttr(149, "/img/svea/icons/BankID_logo.svg"), new HTMLAttr(163, 32), new HTMLAttr(91, 32), ["style", {
                            marginTop: -7,
                            marginBottom: -7,
                        }]], react.createElement("img", keyValueList(props_17, 1))), "BankID (Sverige)"], react.createElement("span", {}, ...children_17)), (_arg_8) => {
                            window.location.href = "/auth/sso";
                        }, defaultProps.Disabled, defaultProps.Id, new SaveStatus_3(0), empty_1(), singleton_1("login-btn-sso"), defaultProps.Icon)));
                    })) : empty_2())))))))))));
                }));
            }));
        }));
        boxContentHtml = react.createElement("div", {
            className: "login__box",
        }, ...children_19);
    }
    if (isAlreadyLoggedIn[0]) {
        const props_31 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "flex-column", "align-items-center", "mt-5"])))];
        const children_29 = [info((`You are already logged in and will be redirected within ${(secondsState[0])} seconds.`).split(""))];
        return react.createElement("div", keyValueList(props_31, 1), ...children_29);
    }
    else {
        return react.createElement("div", {
            className: "login",
        }, boxContentHtml);
    }
}, "Login", uncurry(2, void 0), void 0, "renderLogin", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Login\\View.fs", 450);

